(function () {
  'use strict';

  function initAboutPage() {
    /* Shopify main content first; standalone preview uses #gvfgAboutPage */
    var root = document.querySelector('#MainContent .gvfg-about, .gvfg-about-section-wrapper .gvfg-about, #gvfgAboutPage');
    if (!root || root.dataset.gvfgAboutInit === '1') return;
    root.dataset.gvfgAboutInit = '1';
    root.classList.add('gvfg-about--enhanced');

    /* Scroll reveal */
    var reveals = root.querySelectorAll('.gvfg-about-reveal');
    function showReveal(el) {
      el.classList.add('is-visible');
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              showReveal(e.target);
              io.unobserve(e.target);
            }
          });
        },
        { threshold: 0.08, rootMargin: '0px 0px -20px 0px' }
      );
      reveals.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.92) showReveal(el);
        io.observe(el);
      });
    } else {
      reveals.forEach(showReveal);
    }
    setTimeout(function () {
      reveals.forEach(showReveal);
    }, 1200);

    var hero = root.querySelector('.gvfg-about-hero');
    if (hero) {
      requestAnimationFrame(function () { hero.classList.add('is-visible'); });
    }

    /* Animated counters */
    var counters = root.querySelectorAll('[data-count]');
    var counted = false;
    function runCounters() {
      if (counted) return;
      counted = true;
      counters.forEach(function (el) {
        var target = parseFloat(el.getAttribute('data-count')) || 0;
        var suffix = el.getAttribute('data-suffix') || '';
        var prefix = el.getAttribute('data-prefix') || '';
        var decimals = parseInt(el.getAttribute('data-decimals') || '0', 10);
        var duration = 1800;
        var start = performance.now();
        function tick(now) {
          var p = Math.min((now - start) / duration, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          var val = target * eased;
          el.textContent = prefix + val.toFixed(decimals) + suffix;
          if (p < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      });
    }

    var statsBlock = root.querySelector('.gvfg-about-stats');
    if (statsBlock && 'IntersectionObserver' in window) {
      var statsIo = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          runCounters();
          statsIo.disconnect();
        }
      }, { threshold: 0.3 });
      statsIo.observe(statsBlock);
    }

    /* 3D tilt on icon cards */
    root.querySelectorAll('.gvfg-about-3d-card').forEach(function (card) {
      var inner = card.querySelector('.gvfg-about-3d-card__inner');
      if (!inner) return;
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        inner.style.transform =
          'rotateX(' + (-y * 14) + 'deg) rotateY(' + (x * 14) + 'deg) translateZ(12px)';
      });
      card.addEventListener('mouseleave', function () {
        inner.style.transform = '';
      });
    });

    /* Quality tabs */
    var tabs = root.querySelectorAll('.gvfg-about-quality__tab');
    var panels = root.querySelectorAll('.gvfg-about-quality__panel');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var id = tab.getAttribute('data-quality');
        tabs.forEach(function (t) { t.classList.remove('is-active'); });
        panels.forEach(function (p) { p.classList.remove('is-active'); });
        tab.classList.add('is-active');
        var panel = root.querySelector('[data-quality-panel="' + id + '"]');
        if (panel) panel.classList.add('is-active');
      });
    });

    /* Accordion — native details/summary; keep one panel open at a time */
    root.querySelectorAll('.gvfg-about-acc-item').forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        root.querySelectorAll('.gvfg-about-acc-item[open]').forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });

    /* Smooth scroll for hero links */
    root.querySelectorAll('a[href^="#gvfg-"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href').slice(1);
        var target = document.getElementById(id);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  window.gvfgInitAboutPage = function (force) {
    if (force) {
      document.querySelectorAll('.gvfg-about').forEach(function (el) {
        delete el.dataset.gvfgAboutInit;
      });
    }
    initAboutPage();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAboutPage);
  } else {
    initAboutPage();
  }

  document.addEventListener('shopify:section:load', initAboutPage);
})();